
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as helloo2oXN9POKp_emO7osq5rpTyT058ToJlKpJK3ZN2_1sgMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/hello.vue?macro=true";
import { default as indexujmYVGR5R3TvBiU9LF1WKpwUcweusXSaH_452MvBoP_45NgMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/index.vue?macro=true";
import { default as moBridge4KbatfNcncV0b4xA9n_45mQgBwuccgoNd_45oIK9c2AGDscMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/mo/bridge/moBridge.vue?macro=true";
import { default as indexF5NqK5a1SKybt_42AgRFvmXzaqRI57sAvd8_45xhHBEpYMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/common/info/auto-logout/index.vue?macro=true";
import { default as indexhjgMtKNO_RWK7BlLBajVd4aNrdewjKIW1n9eq_2tE5IMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/common/info/under-maintenance/index.vue?macro=true";
import { default as index4AVfqwODfv2ZVyMJUikG4zoNEqxui2ETYDcFNme1RPoMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/common/password/index.vue?macro=true";
import { default as closeivksCxxSgbyuLhiK5UmDn1e79RK1GzSKwWqZt8E8wFUMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/common/payment/close.vue?macro=true";
import { default as resultZ2c5hsHjTgCgRX4zaYKdGo_3SPvqHLvTJKnguwp4L7kMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/common/payment/result.vue?macro=true";
import { default as indexRRZcwIw4yg8WsR3GefrVWgzxxcTi9Eg8pfwEfELvxfUMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/etc/company-introduction/index.vue?macro=true";
import { default as indexYpii6Yycdu_4573nL5hyaOUuRQNM6WlelgJDGde3BwXbQMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/etc/homepage-use-guide/index.vue?macro=true";
import { default as etcJtNnty1ZeRDaK85V7OcsxRgUy9AvHeRMCPSpE_45nv8s0Meta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/etc.vue?macro=true";
import { default as indexiu1E_45ZavZfoq1kIfcNoQ66EfNbDZfQD6AkhXkOl6uPQMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/inquiry/detail/[inqId]/index.vue?macro=true";
import { default as indexGC1Mlu8PtlQHu1LxZABWn1c5DgsQc6O1uHQ49G_8ve4Meta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/inquiry/list/index.vue?macro=true";
import { default as HcashHistoryPopup2vCYE34kqQXtkbi8951KYBW_e8hC6TpqwRHMn0YlQSMMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/inquiry/popup/HcashHistoryPopup.vue?macro=true";
import { default as OrderHistoryPopupKk46V91v2a_uRSWJv2mB2h8amQcm5q4U0cvidDerqGUMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/inquiry/popup/OrderHistoryPopup.vue?macro=true";
import { default as indexxi7KkLh_7stb0v3SGL_45czLpxmVMIlQPh8TAR_wOpLQYMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/inquiry/register/index.vue?macro=true";
import { default as inquiryaOoMuZLX3k9vkeQXPoAsH4hUZ12xx83UT10lKFki3P8Meta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/inquiry.vue?macro=true";
import { default as indexnR_7JpINNHO2j_wtpUK_452Jxog9fZppOLqAgM88wyZVoMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/join/approval-request-complete/index.vue?macro=true";
import { default as indexeUM1Qoco_Tsz8o6QuKIyhHVpIKBI32AlzedNUhX_yawMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/join/index.vue?macro=true";
import { default as inputValTestPopupTmpyhSgACzaJkz5hRKKbvUsR0oxdmQHbKZvyRR_45tTLOJiYMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/join/inputValTestPopupTmp.vue?macro=true";
import { default as indexqtdAGZHOy9IVZUSvkVZrGPDU6XzmbqRwf5t_45wXbiAAcMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/join/interlock-information/index.vue?macro=true";
import { default as indexfIQr53GTkkdtGnGaiWxK_FUBfm7axglWChF9PRVEPmkMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/join/join-complete/index.vue?macro=true";
import { default as joinSHvHumK2pSZ8n49nzoZyeeVeiaj5RQ3gfAyEGv_45l5B0Meta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/join.vue?macro=true";
import { default as LoginPopup5V9Vm7oW0pF7u461LjmUAAteGygAndUL_455_BEdP5oQQMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/login/LoginPopup.vue?macro=true";
import { default as indexmVq5XjDV2yotFEhHaNJHvED7XgzhLvy0AVBgNuUuvc8Meta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/login/pass-crtf-complete/index.vue?macro=true";
import { default as indexEdsFXYGZuIf2ATT_45ei5zNmzf3D0EuSi0oZfQ3Y7FAFEMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/login/password-reset/index.vue?macro=true";
import { default as indexyMZtCP3n3lXjomzYa1EfwkexW1xdCkodQjb7JLpNeSMMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/login/search-usr-id/complete/index.vue?macro=true";
import { default as indexXqVPDJbCWCtKFDYYbzJVr8UWRPgcntQo1vGrJKPohzkMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/login/search-usr-id/index.vue?macro=true";
import { default as search_45usr_45idwqQSd4MqTW6yY1iO_0kjqSPcEXC2FTqjNLLKZvq4xQwMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/login/search-usr-id.vue?macro=true";
import { default as indexjD1z2XRqYXKlZh4Hp02zOWg1E3hKFuTbmLT3AoJ1_45XsMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/login/search-usr-password/index.vue?macro=true";
import { default as login9MeC3fUv7w26yv15jrEYpqwvLX8lstBoFypye2sFZWAMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/login.vue?macro=true";
import { default as memberhuO3CwgMy0EIDyvn3NoFOfwKywlpdQWhI41JaD0jpS4Meta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member.vue?macro=true";
import { default as indexLfL_45_36FaE7WG3QaCD8whfhJbYrOxUWM9I5E11DR_45P4Meta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/account/index.vue?macro=true";
import { default as indext3OfImMjq0_45EFQfokmn5W_V6J5_45RqwtCzYn7bYZ13pgMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/account/realname/index.vue?macro=true";
import { default as index5npOtG7HG259_45uw6zYWHmX_45D__45FL_45dNTM_d_p9PyaK8Meta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/account/refund/index.vue?macro=true";
import { default as accountBrKTsjnlBRocz3kvEv_45UhCbdU8vEn7XbNEfBEFB5rR4Meta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/account.vue?macro=true";
import { default as createTUq_45EcqX8sqKDNJk_45VQMWpjtsj6LoOl2N6h4OhhhOIQMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/coupon-message/create.vue?macro=true";
import { default as index0MBXfWoohzvixr7OU7kgRst7KeE_G9WizdvCQ_45UdyJoMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/coupon-message/detail/[msgNo]/index.vue?macro=true";
import { default as indexPpNeiR9eRz7kML70OclnlENh8MU8qiGSd04_45kuF3OL0Meta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/coupon-message/index.vue?macro=true";
import { default as coupon_45messageypX_C4u9PB5bk6kY8V7nJKJvV__GyMg9A6W2azV0nBIMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/coupon-message.vue?macro=true";
import { default as indexUXSvJstU7IPNB6jfFDYvCQBcjfDdLAt1ZZJ7lNoUfj4Meta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/coupon-top-image/index.vue?macro=true";
import { default as coupon_45top_45imageFG2JNSzIktYydTWzAu_45mAinbr1T9aL6y1_45wbEniXJ_450Meta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/coupon-top-image.vue?macro=true";
import { default as indexHLh6nEsXxkQa7pfP_d7q0NWsUbkC7J1c44XQ9SQ26HQMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/hcash/charge/complete/index.vue?macro=true";
import { default as index5JDxfckMToABwvqsTBUyG8YkXttaguHQ_45bnRToAWxa4Meta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/hcash/charge/index.vue?macro=true";
import { default as extintionHcashPopup_454BChUBM_UBsx_459Ty0BkhkRXE0uMUu1HzzU5vvaw_45lMMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/hcash/extintionHcashPopup.vue?macro=true";
import { default as indexz4IVbIU1XjtQb0Aj_d5WbtRhT6urR2K9jPgRfLcBi_45kMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/hcash/index.vue?macro=true";
import { default as refundPopup1HZpeqsKcetHAedAjT11vAiKaob0D1CtHPgqaoTChlMMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/hcash/refundPopup.vue?macro=true";
import { default as hcash4_45xD9NLu6n4_RWh3DUIXahmF4OdDUMfaOy0km3HYPqEMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/hcash.vue?macro=true";
import { default as indexH_45j5mjgUFc5LY8417_9Y_45gndp3wGQfgVNqlUcfDr_45YkMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/index.vue?macro=true";
import { default as indexjUA2JJ2FIGQqU__HZACREHTYkYZV_0kzUrLeckYA84wMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/information/index.vue?macro=true";
import { default as indexSoJQHhxVOHwf4jHduWwozFJOmxbWDpprBBjmjLJTdsMMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/information/member-drop-out/complete/index.vue?macro=true";
import { default as indexYBZHHQ93q2zU_45sAvkyuLjI0zhPw5f__45ZjXTNxN6Mtq0Meta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/information/member-drop-out/index.vue?macro=true";
import { default as member_45drop_45out8QrX6h7IDcZvRV1__45gAlEBuZ96OfsH8HJ4bD8wzMqm0Meta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/information/member-drop-out.vue?macro=true";
import { default as informationcUfcVLeP_45AezESjysHKBlfIRJymysD8TMXHNymugMcUMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/information.vue?macro=true";
import { default as indexN2q7ilU0kX6F7yXqV3BHP2wRt1M5iNTHL4cp6dMzqeIMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/mileage/index.vue?macro=true";
import { default as mileagenZn1F_IBgXpWUDFU8e_45O6B2OMGZ8V1az7JFc41Jd3uQMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/mileage.vue?macro=true";
import { default as index0IUGHBeEmbLtPgP9roMsFyEIjCTO3v_458bFkD5hAA99QMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/order/detail/[orderNo]/index.vue?macro=true";
import { default as index80UjNbwjo2gin85Z3z7Kq_45PjmbxfpE5SZ48NC2D4pX0Meta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/order/index.vue?macro=true";
import { default as _91orderNo_93YObGWUr06fPKyCColflMIb3eAuIQ_45afww6ZFpcjSPAwMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/order/pin-detail/[orderNo].vue?macro=true";
import { default as orderTAqcgBGz_83DbDYByzLiM_45OYKOgm3hYKR_AxJB0o0CMMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/order.vue?macro=true";
import { default as index1_458Gr58zM8zKmRa9D5v52qi0wAQ_45aNACHv_45mDRcbs0gMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/pin-publication-request/detail/[pblcNo]/index.vue?macro=true";
import { default as indexdRWaLmeIB5IaAPtLZFhjI1cgEJb1pE1LByBBrPCKXvkMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/pin-publication-request/index.vue?macro=true";
import { default as pin_45publication_45requestSRXyZBtgvGJTGesxTaoYDeeoFpGdtOm7fap2TwcfbAoMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/pin-publication-request.vue?macro=true";
import { default as indexuO7q4DFoL7DlIH7oaB21k3Joimjok3Rc2Ryf73Tlr_45gMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/receive-person/index.vue?macro=true";
import { default as receive_45personfvl51T2Tj56Izdab7fak1l4tudN8y6dwp3DEszptK2EMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/receive-person.vue?macro=true";
import { default as indexCqnFpFe1_xNxFe86bH0Ax4bMVAKL95V1Y2Xi1wzR9N8Meta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/sender/index.vue?macro=true";
import { default as senderANi9p_x40VPrAkqGJ1WqCOCDQkLWbf0E6mDxWLIuU1UMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/sender.vue?macro=true";
import { default as mypagets5ccoooSw_zQ8aEf0mfkuwb_452kmdJgBt9qE1aeiU7wMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage.vue?macro=true";
import { default as index2ZPTxVEV9xqEwidix1okZ4c5CUvkY0LY54MC3Ydz3FIMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/notice/detail/[ntcId]/index.vue?macro=true";
import { default as indexzQ_45SLL1QdAESEq3dV6Ss8mQtx25x1BFuLEEIyy6EfXsMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/notice/list/index.vue?macro=true";
import { default as noticejH4uCIu7NRW6SGUDo2EDeJ6Y_1tLjjk8dzT_WcRhEVcMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/notice.vue?macro=true";
import { default as indexyCmCBdwpcxYTkxYNUYfh3ALcEUvmMxh7uFRJgJtVx90Meta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/order/application-form/index.vue?macro=true";
import { default as indexBxya6lA809F7j9NVClMnvxwbHImKav8wW0SsixKQDTUMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/order/application-form/pin/index.vue?macro=true";
import { default as indexA7rHC3y9mhUxDFg3J2wIOjBlzmPDAOG7lVhoHIDfouMMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/order/basket/index.vue?macro=true";
import { default as indexEAWHGnj_uliUw_7RNSC_45xB4Z2VXmKbS_45gQSfRkvUx4QMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/order/complete/index.vue?macro=true";
import { default as index46hulyRSfnlX8mILNk_UsTEEts7_bmFz0vrQcd_GIpwMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/order/complete/pin/index.vue?macro=true";
import { default as indexV3JM2ZbHHLN3zo4hHuTEU5Od2iZCqFuJio_45ApQUTUzQMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/order/estimate/index.vue?macro=true";
import { default as indexUifRbh7nvWqrIAqfxEF1wHdZvR7mm6mSBAneiwu0OwgMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/order/estimate/list/index.vue?macro=true";
import { default as indexW04uc8wzbxlSLx26c6PhwTLllRoyjL6l8iwd3c_45Gf_454Meta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/order/payment/index.vue?macro=true";
import { default as index7AR_zYz7m0F4mHp_45uZf1UwoPUApeb8SpxA4SKrAAgdAMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/order/payment/pin/index.vue?macro=true";
import { default as indexnSP3dcPa7ru5_IrvBI1IJ9Y948oONWYXvydxLhKOgYUMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/order/temp-save/index.vue?macro=true";
import { default as indexvmvPeupsVMUZ6uGsNgzNEP3IOnTwzcpqMUN_45NhguonMMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/pin-publication-request/index.vue?macro=true";
import { default as index9GbtOzyrfMMZSThiVOkDN87_45r6ROl2l_V1_45foOdw0LoMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/product/detail/[dspGdsCd]/index.vue?macro=true";
import { default as detailqO_45_45P3b2UZaxgSDdsgXoUJB1NRvfsSXCVaqmMiGgWPQMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/product/detail.vue?macro=true";
import { default as indexzDstobXpVWBoiyDCkgyiK7A0479qiReXvzwxCpExS94Meta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/product/main/index.vue?macro=true";
import { default as indexGBEeFIT679EVqVYPFtWOektCFRNH_AyC29TzAJl_45_454gMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/product/no-search-result/index.vue?macro=true";
import { default as index0MdWJQ7lBkx_yT2VpzB2i4gbWDT_45uHd22LN8LEYhGE8Meta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/product/promotion/detail/[prmCd]/index.vue?macro=true";
import { default as indexJ48SGJn_45Xj6oZOaynuOxkNL_zImS_JHaqDomerxeMmMMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/product/promotion/list/index.vue?macro=true";
import { default as promotiondY4KSXUIXtJMXmA0sloIGA2gYdy0pLvWiItj88nFqxwMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/product/promotion.vue?macro=true";
import { default as indexCJkU3H7ni4k7WZu2bvzq5PG0ZTbft0CWGObOzPEA3NgMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/product/search/index.vue?macro=true";
import { default as search5lPSCxE_8F1vIKFc2EtirwAI2N0U9PedW6RBWfgwJnoMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/product/search.vue?macro=true";
import { default as productwrdRb_45nfhf6GByrdrsBxS_AxtT8NFhdiBUbC_45jrel5IMeta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/product.vue?macro=true";
import { default as view4d1qblRCs3deG3ernFbkM7p5ELrzytYTqDYu1lciho8Meta } from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/view.vue?macro=true";
export default [
  {
    name: "hello",
    path: "/hello",
    meta: helloo2oXN9POKp_emO7osq5rpTyT058ToJlKpJK3ZN2_1sgMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/hello.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexujmYVGR5R3TvBiU9LF1WKpwUcweusXSaH_452MvBoP_45NgMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/index.vue")
  },
  {
    name: "mo-bridge-moBridge",
    path: "/mo/bridge/moBridge",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/mo/bridge/moBridge.vue")
  },
  {
    name: "pc-common-info-auto-logout",
    path: "/pc/common/info/auto-logout",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/common/info/auto-logout/index.vue")
  },
  {
    name: "pc-common-info-under-maintenance",
    path: "/pc/common/info/under-maintenance",
    meta: indexhjgMtKNO_RWK7BlLBajVd4aNrdewjKIW1n9eq_2tE5IMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/common/info/under-maintenance/index.vue")
  },
  {
    name: "pc-common-password",
    path: "/pc/common/password",
    meta: index4AVfqwODfv2ZVyMJUikG4zoNEqxui2ETYDcFNme1RPoMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/common/password/index.vue")
  },
  {
    name: "pc-common-payment-close",
    path: "/pc/common/payment/close",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/common/payment/close.vue")
  },
  {
    name: "pc-common-payment-result",
    path: "/pc/common/payment/result",
    meta: resultZ2c5hsHjTgCgRX4zaYKdGo_3SPvqHLvTJKnguwp4L7kMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/common/payment/result.vue")
  },
  {
    name: "pc-etc",
    path: "/pc/etc",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/etc.vue"),
    children: [
  {
    name: "pc-etc-company-introduction",
    path: "company-introduction",
    meta: indexRRZcwIw4yg8WsR3GefrVWgzxxcTi9Eg8pfwEfELvxfUMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/etc/company-introduction/index.vue")
  },
  {
    name: "pc-etc-homepage-use-guide",
    path: "homepage-use-guide",
    meta: indexYpii6Yycdu_4573nL5hyaOUuRQNM6WlelgJDGde3BwXbQMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/etc/homepage-use-guide/index.vue")
  }
]
  },
  {
    name: "pc-inquiry",
    path: "/pc/inquiry",
    meta: inquiryaOoMuZLX3k9vkeQXPoAsH4hUZ12xx83UT10lKFki3P8Meta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/inquiry.vue"),
    children: [
  {
    name: "pc-inquiry-detail-inqId",
    path: "detail/:inqId()",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/inquiry/detail/[inqId]/index.vue")
  },
  {
    name: "pc-inquiry-list",
    path: "list",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/inquiry/list/index.vue")
  },
  {
    name: "pc-inquiry-popup-HcashHistoryPopup",
    path: "popup/HcashHistoryPopup",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/inquiry/popup/HcashHistoryPopup.vue")
  },
  {
    name: "pc-inquiry-popup-OrderHistoryPopup",
    path: "popup/OrderHistoryPopup",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/inquiry/popup/OrderHistoryPopup.vue")
  },
  {
    name: "pc-inquiry-register",
    path: "register",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/inquiry/register/index.vue")
  }
]
  },
  {
    name: "pc-member",
    path: "/pc/member",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member.vue"),
    children: [
  {
    name: joinSHvHumK2pSZ8n49nzoZyeeVeiaj5RQ3gfAyEGv_45l5B0Meta?.name,
    path: "join",
    meta: joinSHvHumK2pSZ8n49nzoZyeeVeiaj5RQ3gfAyEGv_45l5B0Meta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/join.vue"),
    children: [
  {
    name: "pc-member-join-approval-request-complete",
    path: "approval-request-complete",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/join/approval-request-complete/index.vue")
  },
  {
    name: "pc-member-join",
    path: "",
    meta: indexeUM1Qoco_Tsz8o6QuKIyhHVpIKBI32AlzedNUhX_yawMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/join/index.vue")
  },
  {
    name: "pc-member-join-inputValTestPopupTmp",
    path: "inputValTestPopupTmp",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/join/inputValTestPopupTmp.vue")
  },
  {
    name: "pc-member-join-interlock-information",
    path: "interlock-information",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/join/interlock-information/index.vue")
  },
  {
    name: "pc-member-join-join-complete",
    path: "join-complete",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/join/join-complete/index.vue")
  }
]
  },
  {
    name: "pc-member-login",
    path: "login",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/login.vue"),
    children: [
  {
    name: "pc-member-login-LoginPopup",
    path: "LoginPopup",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/login/LoginPopup.vue")
  },
  {
    name: "pc-member-login-pass-crtf-complete",
    path: "pass-crtf-complete",
    meta: indexmVq5XjDV2yotFEhHaNJHvED7XgzhLvy0AVBgNuUuvc8Meta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/login/pass-crtf-complete/index.vue")
  },
  {
    name: "pc-member-login-password-reset",
    path: "password-reset",
    meta: indexEdsFXYGZuIf2ATT_45ei5zNmzf3D0EuSi0oZfQ3Y7FAFEMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/login/password-reset/index.vue")
  },
  {
    name: search_45usr_45idwqQSd4MqTW6yY1iO_0kjqSPcEXC2FTqjNLLKZvq4xQwMeta?.name,
    path: "search-usr-id",
    meta: search_45usr_45idwqQSd4MqTW6yY1iO_0kjqSPcEXC2FTqjNLLKZvq4xQwMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/login/search-usr-id.vue"),
    children: [
  {
    name: "pc-member-login-search-usr-id-complete",
    path: "complete",
    meta: indexyMZtCP3n3lXjomzYa1EfwkexW1xdCkodQjb7JLpNeSMMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/login/search-usr-id/complete/index.vue")
  },
  {
    name: "pc-member-login-search-usr-id",
    path: "",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/login/search-usr-id/index.vue")
  }
]
  },
  {
    name: "pc-member-login-search-usr-password",
    path: "search-usr-password",
    meta: indexjD1z2XRqYXKlZh4Hp02zOWg1E3hKFuTbmLT3AoJ1_45XsMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/member/login/search-usr-password/index.vue")
  }
]
  }
]
  },
  {
    name: mypagets5ccoooSw_zQ8aEf0mfkuwb_452kmdJgBt9qE1aeiU7wMeta?.name,
    path: "/pc/mypage",
    meta: mypagets5ccoooSw_zQ8aEf0mfkuwb_452kmdJgBt9qE1aeiU7wMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage.vue"),
    children: [
  {
    name: accountBrKTsjnlBRocz3kvEv_45UhCbdU8vEn7XbNEfBEFB5rR4Meta?.name,
    path: "account",
    meta: accountBrKTsjnlBRocz3kvEv_45UhCbdU8vEn7XbNEfBEFB5rR4Meta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/account.vue"),
    children: [
  {
    name: "pc-mypage-account",
    path: "",
    meta: indexLfL_45_36FaE7WG3QaCD8whfhJbYrOxUWM9I5E11DR_45P4Meta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/account/index.vue")
  },
  {
    name: "pc-mypage-account-realname",
    path: "realname",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/account/realname/index.vue")
  },
  {
    name: "pc-mypage-account-refund",
    path: "refund",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/account/refund/index.vue")
  }
]
  },
  {
    name: coupon_45messageypX_C4u9PB5bk6kY8V7nJKJvV__GyMg9A6W2azV0nBIMeta?.name,
    path: "coupon-message",
    meta: coupon_45messageypX_C4u9PB5bk6kY8V7nJKJvV__GyMg9A6W2azV0nBIMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/coupon-message.vue"),
    children: [
  {
    name: "pc-mypage-coupon-message-create",
    path: "create",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/coupon-message/create.vue")
  },
  {
    name: "pc-mypage-coupon-message-detail-msgNo",
    path: "detail/:msgNo()",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/coupon-message/detail/[msgNo]/index.vue")
  },
  {
    name: "pc-mypage-coupon-message",
    path: "",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/coupon-message/index.vue")
  }
]
  },
  {
    name: coupon_45top_45imageFG2JNSzIktYydTWzAu_45mAinbr1T9aL6y1_45wbEniXJ_450Meta?.name,
    path: "coupon-top-image",
    meta: coupon_45top_45imageFG2JNSzIktYydTWzAu_45mAinbr1T9aL6y1_45wbEniXJ_450Meta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/coupon-top-image.vue"),
    children: [
  {
    name: "pc-mypage-coupon-top-image",
    path: "",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/coupon-top-image/index.vue")
  }
]
  },
  {
    name: hcash4_45xD9NLu6n4_RWh3DUIXahmF4OdDUMfaOy0km3HYPqEMeta?.name,
    path: "hcash",
    meta: hcash4_45xD9NLu6n4_RWh3DUIXahmF4OdDUMfaOy0km3HYPqEMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/hcash.vue"),
    children: [
  {
    name: "pc-mypage-hcash-charge-complete",
    path: "charge/complete",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/hcash/charge/complete/index.vue")
  },
  {
    name: "pc-mypage-hcash-charge",
    path: "charge",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/hcash/charge/index.vue")
  },
  {
    name: "pc-mypage-hcash-extintionHcashPopup",
    path: "extintionHcashPopup",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/hcash/extintionHcashPopup.vue")
  },
  {
    name: "pc-mypage-hcash",
    path: "",
    meta: indexz4IVbIU1XjtQb0Aj_d5WbtRhT6urR2K9jPgRfLcBi_45kMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/hcash/index.vue")
  },
  {
    name: "pc-mypage-hcash-refundPopup",
    path: "refundPopup",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/hcash/refundPopup.vue")
  }
]
  },
  {
    name: "pc-mypage",
    path: "",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/index.vue")
  },
  {
    name: informationcUfcVLeP_45AezESjysHKBlfIRJymysD8TMXHNymugMcUMeta?.name,
    path: "information",
    meta: informationcUfcVLeP_45AezESjysHKBlfIRJymysD8TMXHNymugMcUMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/information.vue"),
    children: [
  {
    name: "pc-mypage-information",
    path: "",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/information/index.vue")
  },
  {
    name: member_45drop_45out8QrX6h7IDcZvRV1__45gAlEBuZ96OfsH8HJ4bD8wzMqm0Meta?.name,
    path: "member-drop-out",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/information/member-drop-out.vue"),
    children: [
  {
    name: "pc-mypage-information-member-drop-out-complete",
    path: "complete",
    meta: indexSoJQHhxVOHwf4jHduWwozFJOmxbWDpprBBjmjLJTdsMMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/information/member-drop-out/complete/index.vue")
  },
  {
    name: "pc-mypage-information-member-drop-out",
    path: "",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/information/member-drop-out/index.vue")
  }
]
  }
]
  },
  {
    name: mileagenZn1F_IBgXpWUDFU8e_45O6B2OMGZ8V1az7JFc41Jd3uQMeta?.name,
    path: "mileage",
    meta: mileagenZn1F_IBgXpWUDFU8e_45O6B2OMGZ8V1az7JFc41Jd3uQMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/mileage.vue"),
    children: [
  {
    name: "pc-mypage-mileage",
    path: "",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/mileage/index.vue")
  }
]
  },
  {
    name: orderTAqcgBGz_83DbDYByzLiM_45OYKOgm3hYKR_AxJB0o0CMMeta?.name,
    path: "order",
    meta: orderTAqcgBGz_83DbDYByzLiM_45OYKOgm3hYKR_AxJB0o0CMMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/order.vue"),
    children: [
  {
    name: "pc-mypage-order-detail-orderNo",
    path: "detail/:orderNo()",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/order/detail/[orderNo]/index.vue")
  },
  {
    name: "pc-mypage-order",
    path: "",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/order/index.vue")
  },
  {
    name: "pc-mypage-order-pin-detail-orderNo",
    path: "pin-detail/:orderNo()",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/order/pin-detail/[orderNo].vue")
  }
]
  },
  {
    name: pin_45publication_45requestSRXyZBtgvGJTGesxTaoYDeeoFpGdtOm7fap2TwcfbAoMeta?.name,
    path: "pin-publication-request",
    meta: pin_45publication_45requestSRXyZBtgvGJTGesxTaoYDeeoFpGdtOm7fap2TwcfbAoMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/pin-publication-request.vue"),
    children: [
  {
    name: "pc-mypage-pin-publication-request-detail-pblcNo",
    path: "detail/:pblcNo()",
    meta: index1_458Gr58zM8zKmRa9D5v52qi0wAQ_45aNACHv_45mDRcbs0gMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/pin-publication-request/detail/[pblcNo]/index.vue")
  },
  {
    name: "pc-mypage-pin-publication-request",
    path: "",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/pin-publication-request/index.vue")
  }
]
  },
  {
    name: receive_45personfvl51T2Tj56Izdab7fak1l4tudN8y6dwp3DEszptK2EMeta?.name,
    path: "receive-person",
    meta: receive_45personfvl51T2Tj56Izdab7fak1l4tudN8y6dwp3DEszptK2EMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/receive-person.vue"),
    children: [
  {
    name: "pc-mypage-receive-person",
    path: "",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/receive-person/index.vue")
  }
]
  },
  {
    name: senderANi9p_x40VPrAkqGJ1WqCOCDQkLWbf0E6mDxWLIuU1UMeta?.name,
    path: "sender",
    meta: senderANi9p_x40VPrAkqGJ1WqCOCDQkLWbf0E6mDxWLIuU1UMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/sender.vue"),
    children: [
  {
    name: "pc-mypage-sender",
    path: "",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/mypage/sender/index.vue")
  }
]
  }
]
  },
  {
    name: "pc-notice",
    path: "/pc/notice",
    meta: noticejH4uCIu7NRW6SGUDo2EDeJ6Y_1tLjjk8dzT_WcRhEVcMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/notice.vue"),
    children: [
  {
    name: "pc-notice-detail-ntcId",
    path: "detail/:ntcId()",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/notice/detail/[ntcId]/index.vue")
  },
  {
    name: "pc-notice-list",
    path: "list",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/notice/list/index.vue")
  }
]
  },
  {
    name: "pc-order-application-form",
    path: "/pc/order/application-form",
    meta: indexyCmCBdwpcxYTkxYNUYfh3ALcEUvmMxh7uFRJgJtVx90Meta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/order/application-form/index.vue")
  },
  {
    name: "pc-order-application-form-pin",
    path: "/pc/order/application-form/pin",
    meta: indexBxya6lA809F7j9NVClMnvxwbHImKav8wW0SsixKQDTUMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/order/application-form/pin/index.vue")
  },
  {
    name: "pc-order-basket",
    path: "/pc/order/basket",
    meta: indexA7rHC3y9mhUxDFg3J2wIOjBlzmPDAOG7lVhoHIDfouMMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/order/basket/index.vue")
  },
  {
    name: "pc-order-complete",
    path: "/pc/order/complete",
    meta: indexEAWHGnj_uliUw_7RNSC_45xB4Z2VXmKbS_45gQSfRkvUx4QMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/order/complete/index.vue")
  },
  {
    name: "pc-order-complete-pin",
    path: "/pc/order/complete/pin",
    meta: index46hulyRSfnlX8mILNk_UsTEEts7_bmFz0vrQcd_GIpwMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/order/complete/pin/index.vue")
  },
  {
    name: "pc-order-estimate",
    path: "/pc/order/estimate",
    meta: indexV3JM2ZbHHLN3zo4hHuTEU5Od2iZCqFuJio_45ApQUTUzQMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/order/estimate/index.vue")
  },
  {
    name: "pc-order-estimate-list",
    path: "/pc/order/estimate/list",
    meta: indexUifRbh7nvWqrIAqfxEF1wHdZvR7mm6mSBAneiwu0OwgMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/order/estimate/list/index.vue")
  },
  {
    name: "pc-order-payment",
    path: "/pc/order/payment",
    meta: indexW04uc8wzbxlSLx26c6PhwTLllRoyjL6l8iwd3c_45Gf_454Meta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/order/payment/index.vue")
  },
  {
    name: "pc-order-payment-pin",
    path: "/pc/order/payment/pin",
    meta: index7AR_zYz7m0F4mHp_45uZf1UwoPUApeb8SpxA4SKrAAgdAMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/order/payment/pin/index.vue")
  },
  {
    name: "pc-order-temp-save",
    path: "/pc/order/temp-save",
    meta: indexnSP3dcPa7ru5_IrvBI1IJ9Y948oONWYXvydxLhKOgYUMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/order/temp-save/index.vue")
  },
  {
    name: "pc-pin-publication-request",
    path: "/pc/pin-publication-request",
    meta: indexvmvPeupsVMUZ6uGsNgzNEP3IOnTwzcpqMUN_45NhguonMMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/pin-publication-request/index.vue")
  },
  {
    name: "pc-product",
    path: "/pc/product",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/product.vue"),
    children: [
  {
    name: "pc-product-detail",
    path: "detail",
    meta: detailqO_45_45P3b2UZaxgSDdsgXoUJB1NRvfsSXCVaqmMiGgWPQMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/product/detail.vue"),
    children: [
  {
    name: "pc-product-detail-dspGdsCd",
    path: ":dspGdsCd()",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/product/detail/[dspGdsCd]/index.vue")
  }
]
  },
  {
    name: "pc-product-main",
    path: "main",
    meta: indexzDstobXpVWBoiyDCkgyiK7A0479qiReXvzwxCpExS94Meta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/product/main/index.vue")
  },
  {
    name: "pc-product-no-search-result",
    path: "no-search-result",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/product/no-search-result/index.vue")
  },
  {
    name: "pc-product-promotion",
    path: "promotion",
    meta: promotiondY4KSXUIXtJMXmA0sloIGA2gYdy0pLvWiItj88nFqxwMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/product/promotion.vue"),
    children: [
  {
    name: "pc-product-promotion-detail-prmCd",
    path: "detail/:prmCd()",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/product/promotion/detail/[prmCd]/index.vue")
  },
  {
    name: "pc-product-promotion-list",
    path: "list",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/product/promotion/list/index.vue")
  }
]
  },
  {
    name: search5lPSCxE_8F1vIKFc2EtirwAI2N0U9PedW6RBWfgwJnoMeta?.name,
    path: "search",
    meta: search5lPSCxE_8F1vIKFc2EtirwAI2N0U9PedW6RBWfgwJnoMeta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/product/search.vue"),
    children: [
  {
    name: "pc-product-search",
    path: "",
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/pc/product/search/index.vue")
  }
]
  }
]
  },
  {
    name: "view",
    path: "/view",
    meta: view4d1qblRCs3deG3ernFbkM7p5ELrzytYTqDYu1lciho8Meta || {},
    component: () => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/pages/view.vue")
  }
]